import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../axiosInstance.js';
import TagsInput from './TagsInput.js';
import MyUserContext from '../myUserContext.js';
import ArtEventDropdown from './ArtEventDropdown'; // Import ArtEventDropdown component
import { Button } from "@mantine/core";

const CardEventArtChatMini = ({ art }) => {
  const myUser = useContext(MyUserContext);

  // For my event.
  const [artEvent, setArtEvent] = useState(null);
  const [myEvent, setMyEvent] = useState(null);
  useEffect(() => {
    if (art.myEventId) {
      axiosInstance
        .get(`/artEvents/${art.myEventId}`)
        .then((response) => {
          setArtEvent(response.data);
          setMyEvent(response.data.event);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [art.myEventId]);

  // For other people events.
  const [currentEvent, setCurrentEvent] = useState(null);
  const [eventCache, setEventCache] = useState({});
  const otherPersonEventId = art.otherPeopleEvents && art.otherPeopleEvents.length > 0
    ? art.otherPeopleEvents[0].artEventId
    : null;

  useEffect(() => {
    if (art.otherPeopleEvents && art.otherPeopleEvents.length > 0) {
      const fetchAllEvents = async () => {
        const cache = {};
        await Promise.all(
          art.otherPeopleEvents.map(({ artEventId }) =>
            axiosInstance
              .get(`/artEvents/${artEventId}`)
              .then((response) => {
                cache[artEventId] = response.data.event;
              })
              .catch((error) => {
                console.error(`Failed to fetch event ${artEventId}:`, error);
              })
          )
        );
        setEventCache(cache);
      };
      fetchAllEvents();
    }
  }, [art.otherPeopleEvents]);

  useEffect(() => {
    if (otherPersonEventId) {
      fetchEvent(otherPersonEventId);
    }
  }, [otherPersonEventId]);

  const fetchEvent = (eventId) => {
    if (eventCache[eventId]) {
      setCurrentEvent(eventCache[eventId]);
    } else {
      axiosInstance
        .get(`/artEvents/${eventId}`)
        .then((response) => {
          setCurrentEvent(response.data.event);
          setEventCache((prevCache) => ({
            ...prevCache,
            [eventId]: response.data.event,
          }));
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const language = myUser ? myUser.myUserSettings.lang : 'ru';

  const [isArtEventDropdownOpen, setIsArtEventDropdownOpen] = useState(false); // State for dropdown visibility

  return (
    <div className="mx-auto max-w-xl">

      {/* My tags are always to be selected */}
      {/* <h3 className="text-center text-lg font-semibold mb-5">
        {language === "ru" 
          ? (!myEvent ? "Выберите тэг" : "Мои тэги") 
          : (!myEvent ? "Select tag" : "My tags")}
      </h3> */}

      <div className="flex justify-center">
        <TagsInput
          key={`${"myEvent"}-${Date.now()}`} // Force re-render with unique key
          language={language}
          editable={true} // Ensure correct field comparison
          initialTags={myEvent?.eventTags?.map((tag) => tag.name) || []}
          initialTagObjects={myEvent?.eventTags || []}
          onTagsChange={(actualTagNames) => {
            if (myEvent === null) {
              axiosInstance
                .post(`/artEvents`, { globalManualTag: actualTagNames[0], artId: art.id, type: "like" /*todo: remove once backend is ready, type is legacy*/ })
                .then((response) => {
                  setMyEvent(response.data.event);
                })
                .catch((error) => {
                  console.error(error);
                });
              return;
            } else {
              axiosInstance
                .post(`/artEvents/tag/${myEvent.id}/tag`, { tags: actualTagNames })
                .then((response) => {
                  setMyEvent(response.data.event);
                })
                .catch((error) => {
                  console.error(error);
                });
            }
          }}
        />
      </div>
      {myEvent && (
        <div className="flex justify-center text-center mt-2 mb-1 space-x-4">
          <Button
            variant="subtle"
            size="sm"
            onClick={() => setIsArtEventDropdownOpen(true)} // Open dropdown on button click
          >
            <img
              src="/chat_icon.png"
              alt={language === "ru" ? "Перейти к моему чату" : "Go to my discussion"}
              title={language === "ru" ? "Перейти к моему чату" : "Go to my discussion"}
              className="inline-block w-10 h-10"
              style={{ filter: 'var(--icon-filter)' }}
            />
          </Button>
        </div>
      )}
      {isArtEventDropdownOpen && (
        <ArtEventDropdown
          eventId={myEvent.id} // Pass myEvent.id explicitly
          onClose={() => setIsArtEventDropdownOpen(false)} // Close dropdown handler
          language={language}
          eventType="artEvent"
          initialArtEvent={artEvent}
        />
      )}
    </div>
  );
};

export default CardEventArtChatMini;